import { Disclaimer } from 'components/Disclaimer';

const ScreenDisclaimer = () => <Disclaimer />;

export default ScreenDisclaimer;
